/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalGrillW30Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalGrillW30').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'GRILL_LYNX_PROFESSIONAL_L30',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-grill-w-30.js.map